import React from 'react';
export function HomeFAQHeader() {
  return <h2 className="text-4xl md:text-5xl text-ink text-center mb-16" data-id="element-1662">
      Questions Before You Start?
    </h2>;
}